import { createElement, lazy, type ComponentType } from 'react';
import { telasCFG } from './registros/CFG';
import { telasCOM } from './registros/COM';
import { telasEST } from './registros/EST';
import { telasFAT } from './registros/FAT';
import { telasFIN } from './registros/FIN';
import { telasFIS } from './registros/FIS';
import type { TelaRotina } from './tipoTelaRotina';

/** O shell conhece apenas os registros; cada modulo cuida das suas telas lazy. */
export const telasRotina: Record<string, TelaRotina> = {
  ...telasCFG,
  ...telasFAT,
  ...telasFIN,
  ...telasFIS,
  ...telasEST,
  ...telasCOM,
  relatorio: lazy(() => import('./PaginaRelatorio').then((m) => ({ default: m.PaginaRelatorio }))),
  diagnostico: lazy(() => import('./PaginaDiagnostico').then((m) => ({ default: (() => createElement(m.PaginaDiagnostico)) as ComponentType<{ codigo: string }> }))),
};
